import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CloseIcon from 'app/components/Icons/CloseIcon';
import StarIcon from 'app/components/Icons/StarIcon';

import {
  closeBtn,
  dialogActions,
  dialogContent,
  dialogTitle,
  paperProps,
  rateBox,
  rateTypo,
  starBox,
  textField,
  textFieldTypo,
} from 'app/providers/csi/components/modal/feedback.sx';

interface Props {
  open: boolean;
  showText?: boolean;
  hideBackdrop?: boolean;
  close: VoidFunction;
  submit: (rating: number, comment: string) => void;
}

export const FeedbackModal = (props: Props) => {
  const { open, showText, hideBackdrop = false, close, submit } = props;
  const { t } = useTranslation();

  const [starIndex, setStarIndex] = useState(0);
  const [starIndexHover, setStarIndexHover] = useState(0);
  const [value, setValue] = useState('');

  const rates = ['veryBad', 'bad', 'normal', 'good', 'excellent'];

  const handleChange = (event: any) => {
    setValue(event.target.value);
  };

  const handleClean = () => {
    setStarIndex(0);
    setValue('');
  };

  const handleClose = () => {
    close();
    handleClean();
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      hideBackdrop={hideBackdrop}
      onClose={handleClose}
    >
      <DialogTitle sx={{ ...dialogTitle, mb: '12px' }}>
        <Typography textAlign='center' fontWeight={600} fontSize={24}>
          {t('csi.evaluateProcess')}
        </Typography>
        <Button color={'tertiary'} onClick={handleClose} sx={closeBtn}>
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent sx={dialogContent}>
        {showText && (
          <Typography sx={{ maxWidth: '370px' }} fontWeight={400} fontSize={16}>
            {t('csi.shareExperience')}
          </Typography>
        )}
        <Box onMouseLeave={() => setStarIndexHover(0)} sx={rateBox}>
          {rates.map((rate, index) => (
            <Box
              sx={starBox}
              onMouseEnter={() => {
                setStarIndexHover(index + 1);
              }}
              onClick={() => {
                setStarIndex(index + 1);
              }}
              key={index}
            >
              <StarIcon
                color={index > starIndex - 1 && index > starIndexHover - 1 ? 'secondary' : null}
                width={28}
              />
              {((index === starIndex - 1 && starIndexHover === 0) ||
                index === starIndexHover - 1) && (
                <Typography sx={rateTypo}>{t(`csi.${rate}`)}</Typography>
              )}
            </Box>
          ))}
        </Box>

        <TextField
          sx={textField}
          inputProps={{
            maxLength: 100,
          }}
          multiline
          rows={4}
          variant='outlined'
          placeholder='Qeydiniz'
          value={value}
          onChange={handleChange}
        />
        <Typography sx={{ ...textFieldTypo, color: value.length === 100 ? 'red' : '#14191F66' }}>
          {value.length}/100
        </Typography>
      </DialogContent>
      <DialogActions sx={dialogActions}>
        <Button
          disabled={starIndex === 0}
          sx={{ width: '100%' }}
          onClick={() => {
            submit(starIndex, value);
            handleClose();
          }}
        >
          {t('csi.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackModal;
